import type { FaireProductEntity } from "../../entity_types/product";

export const p_rc7vr9c3up: FaireProductEntity = {
  token: "p_rc7vr9c3up",
  type: "product",
  name: "STAR BURST 4 CZ GEM 316L SURGICAL STEEL THREADLESS (PUSH IN)",
  brandToken: "b_punhnqvhh6",
  brandName: "CRAVE",
  imageUrl:
    "https://cdn.faire.com/fastly/b88030d1d26f4d65e1b6aeb92e14778e8e0dda70022bc8dc5bf81b56f9c12d25.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47312defe3359323cee9c888b65ab03fe0489b53de15f10517e4157af639eaa1.jpeg",
    "https://cdn.faire.com/fastly/56bd2aacec52177f20e74bbf8a0878002c9d215b581169e6a7a290139811cbc2.jpeg",
    "https://cdn.faire.com/fastly/b978a8aba6801748dffc6a763d1c37f68189c53d82b5a630d8e8559f4563e51d.jpeg",
    "https://cdn.faire.com/fastly/1e41564ee0c48e2fce3821257374d0e784d44eacfcc2e6038a0b7a6f3b28c47f.jpeg",
    "https://cdn.faire.com/fastly/52e42b61ce908a5da526dbb5750ccfe097b892b3a10ffe27c701a6a5eff58a8b.jpeg",
  ],
  priceDollars: 2.99,
  description:
    'STAR BURST 4 CZ GEM 316L SURGICAL STEEL THREADLESS (PUSH IN) LABRET SET\n\nProduct Code: LB352PI\nMaterial: 316L Surgical Steel/Brass\nSold By: PIECE\nThickness: 18GA (1.0mm)\nLength: 1/4"(6mm) or 5/16" (8mm)',
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:01.432Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
